<template>
    <div class="d-flex justify-center align-center fill-height">
        <div class="text-center">
            <v-img :src="imagePath('logo')" width="350px"></v-img>
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'splash',
        data: function () {
            return {}
        },
    }
</script>